export default "__VITE_ASSET__IQ0oIXAD__"